var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 text-light"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"page-h1"},[_vm._v(_vm._s(_vm.initialTitle))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }